import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Mental} from "../Mental";
import {MentalGameAssets} from "../MentalGameAssets";
import {MentalGameMode} from "../server/MentalGameMode";
import {TimelineLite} from "gsap";
import {MentalHelper} from "../utils/MentalHelper";
import {SoundManager} from "../sound/SoundManager";
import {MentalSoundConfig} from "../MentalSoundConfig";
import {WinRatioType} from "../../framework/winPresentation/IWinRatios";

export class MentalBackground extends PIXI.Container implements StageLayer {
    private _background: PIXI.Sprite;
    private _backgroundSpine: PIXI.spine.Spine;
    private _backgroundContainer: PIXI.Container;
    private _currentMode: string;
    private _spineTagsForFs: string[] = ["fs_bg", "fs_cool_bg", "fs_super_cool_bg"];
    private _flickerTl: TimelineLite;
    private _prevFlickerSoundIdx: number = -1;

    constructor() {
        super();
        this.initializeBackground();
    }

    public onResize(): void {
        this._backgroundContainer.position.set(360, 360);
    }

    public flickBackgroundLight(isFromOutro: boolean = false): void {
        if (this._currentMode === MentalGameMode.NORMAL || isFromOutro) {
            // #116
            this.playLightFlickerSound();

            this._backgroundSpine.state.clearTrack(1);
            this._backgroundSpine.state.setAnimation(1, "main_bg_fliker", false);

            this._flickerTl = MentalHelper.timeLineKiller(this._flickerTl, new TimelineLite());
            this._flickerTl.add(() => this.flickBackgroundLight(), this.getRandomTime()); // #131
        }
    }

    public clearFlickAnimation(): void {
        if (this._currentMode === MentalGameMode.NORMAL && this._backgroundSpine.state.tracks[1]) {
            this._backgroundSpine.state.tracks[1].trackTime = 2;
        }

        if (this._flickerTl) {
            this._flickerTl.clear();
            this._flickerTl.kill();
        }
    }

    public playWinFlickerAnim(winType: WinRatioType, loopCount: number): void {
        let gameType: string;
        switch (this._currentMode) {
            case MentalGameMode.STANDARD_FREESPIN:
                gameType = "standard";
                break;
            case MentalGameMode.COOL_FREESPIN:
                gameType = "cool_fs";
                break;
            case MentalGameMode.SUPER_FREESPIN:
                gameType = "super_fs";
                break;
            default:
                gameType = "main";
                break;
        }
        this.clearFlickAnimation();
        this.playLightFlickerSound();
        this._backgroundSpine.state.clearTrack(1);
        this._backgroundSpine.state.setAnimation(1, gameType + "_bg_fliker_" + winType, (loopCount === -1));
    }

    public stopWinFlicker(): void {
        if (this._backgroundSpine.state.tracks[1]) {
            this._backgroundSpine.state.tracks[1].trackTime = 2;
        }

        this._backgroundSpine.state.clearTrack(1);
    }

    /**
     * function to change background on mode change.
     * @param mode
     */
    public onChangeMode(mode: string): void {
        this._currentMode = mode;
        this._backgroundSpine.state.clearTracks();
        this._backgroundSpine.skeleton.setToSetupPose();
        switch (mode) {
            case MentalGameMode.NORMAL:
                this._backgroundSpine.state.setAnimation(0, "main_bg", false);
                break;
            case MentalGameMode.STANDARD_FREESPIN:
                this._backgroundSpine.state.setAnimation(0, this._spineTagsForFs[0], false);
                break;
            case MentalGameMode.COOL_FREESPIN:
                this._backgroundSpine.state.setAnimation(0, this._spineTagsForFs[1], false);
                break;
            case MentalGameMode.SUPER_FREESPIN:
                this._backgroundSpine.state.setAnimation(0, this._spineTagsForFs[2], false);
                break;
        }
    }

    public getRandomTime(): number {
        let randomNum: number;

        if (this._prevFlickerSoundIdx === -1) {
            //on game start
            randomNum = Math.floor(Math.random() * 5);
        } else {
            randomNum = Math.floor(Math.random() * 10) + 5;
        }

        return randomNum;
    }

    /**
     * function to initialize backgrounds.
     */
    private initializeBackground(): void {
        this._backgroundContainer = new PIXI.Container();

        this._backgroundSpine = new PIXI.spine.Spine(Mental.assetLoader.getSpineAsset("background"));

        this._background = new PIXI.Sprite(Mental.assetLoader.getTextures(MentalGameAssets.MAIN_GAME_BACKGROUND)[0]);
        const backgroundLight = new PIXI.Sprite(Mental.assetLoader.getTextures(MentalGameAssets.BG_LIGHT)[0]);
        const backgroundLightCap = new PIXI.Sprite(Mental.assetLoader.getTextures(MentalGameAssets.BG_LIGHT_CAP)[0]);
        backgroundLight.blendMode = PIXI.BLEND_MODES.SCREEN;
        backgroundLightCap.position.set(730, 445);
        this._backgroundContainer.addChild(this._backgroundSpine);
        this.addChild(this._backgroundContainer);
        this.onResize();
    }

    // #116
    private playLightFlickerSound(): void {
        const min: number = 0,
            max: number = 3;
        let soundIdx: number = MentalHelper.getRandomIntInRange(min, max);
        soundIdx = Number(soundIdx.toFixed(0));
        // no 2(back to back) flicker sound name shall be same
        while (soundIdx === this._prevFlickerSoundIdx) {
            soundIdx = MentalHelper.getRandomIntInRange(min, max);
        }
        this._prevFlickerSoundIdx = soundIdx;
        SoundManager.playSoundEffect(MentalSoundConfig.LIGHTS_FLICKER[soundIdx]);
    }
}